import { observable, action, makeObservable } from "mobx";

class MapStore {
  mapReady = false;
  map = {};
  mapView = {};
  mapWidgets = {};
  basemapGallery = null;
  isPrintWidgetExpanded = false;
  popup = null;
  popupOpened = false;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      mapReady: observable,
      map: observable,
      mapView: observable,
      isPrintWidgetExpanded: observable,
      setPrintWidgetExpanded: action,
      basemapGallery: observable.ref,
      setMapReady: action,
      popup: observable.ref,
      popupOpened: observable.ref,
    });
  }

  setPrintWidgetExpanded = (isExpanded) => {
    this.isPrintWidgetExpanded = isExpanded;
  };

  setMapReady = (ready) => {
    this.mapReady = ready;
  };
}

export default MapStore;
